import { DefaultError, useMutation } from "@tanstack/react-query";
import { updateFaq } from "../api/updateFaq";
import { invalidateFaqsListByFaqGroupQuery } from "../queries/useFaqsListByFaqGroupQuery";
import { FaqDataToUpdate } from "../types";

type Params = {
  faqData: FaqDataToUpdate;
  faqId: string;
  faqGroupId: string;
};

export const useUpdateFaqMutation = () => {
  return useMutation<void, DefaultError, Params>({
    mutationFn: async (params) => {
      await updateFaq(params);
    },
    onSuccess: (_, { faqGroupId }) => {
      invalidateFaqsListByFaqGroupQuery(faqGroupId);
    },
    onError: (e) => {
      console.error("Error occurred when updating faq", e);
    },
  });
};
